export enum DebtPostOfficeStatus {
    Collected = 1,
    NotYetCollect = 2
}